<template>
  <v-container fluid class="px-0 py-0">
    <v-tabs v-model="displayedTab" background-color="integrity" dark show-arrows icons-and-text>
      <v-tab value="0">
        Info
        <v-icon>mdi-information-outline</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="displayedTab">
      <v-tab-item>
        <DriverDetail />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<style scoped>
</style>

<script>
import DriverDetail from '@/components/Client/LineOfBusiness/Drivers/Driver/DriverDetail.vue';
import { mapState } from 'vuex';

export default {
  name: 'Driver',
  components: {
    DriverDetail
  },
  data: function () {
    return {
      displayedTab: 0,
      loading: true
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    driverId: function () {
      return this.$route.params.driverId;
    }
  }
};
</script>
